<!-- 视频播放器 支持flv流,mp4文件，原生初版 功能单一，只做播放展示用-->
<template>
    <div class="player-box" :style="{background:isFirefox?'#000':'transparent'} ">
        <div class="loader" v-show="isLoading">
            <svg
                    version="1.1"
                    class="loader-1"
                    x="0px"
                    y="0px"
                    width="100px"
                    height="100px"
                    viewBox="0 0 50 50"
                    style="enable-background:new 0 0 50 50;"
                    xml:space="preserve"
            >
              <path
                      fill="#000"
                      d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                      transform="rotate(110.097 25 25)"
              >
                <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.6s"
                        repeatCount="indefinite"
                />
              </path>
            </svg>
            <div class="load-msg">加载中,请稍后....</div>
        </div>
        <video ref="flvPlayerVideoRef"
               :poster="poster"
               :controls="controls"
               class="video-body"
               @ended="ended($event)"
               @error="error($event)"
               @loadstart="loadstart($event)"
               @canplay="canplay($event)"
               autoplay
               muted>
            您的浏览器不支持video
        </video>
    </div>
</template>

<script>

    import flvjs from "flv.js";
    import {isFirefoxBrowser} from '@/utils/index';

    export default {
        name: 'videoPlayer',
        props: {
            width: {type: String},
            height: {type: String},
            videoUrl:{type: String},
            controls:{
                type: Boolean,
                default:true
            },
            limitReloadCount:{
                type: Number,
                default:10,
            },
            poster:{
                type:String,
                default:require('@/assets/img/bigScreen/defaultVideoBg.png')

            },
            videoCode: {
                type: String,
                default: "mp4", //只支持mp4或MP4
                validator: function (value) {
                    // 这个值必须匹配下列字符串中的一个
                    return ["flv", "MP4"].indexOf(value) !== -1;
                },
            },
            voice:{
                type: Boolean,
                default:true,
            },
            id:{
                type: String,
                default:'1'
            },
            serverUrl:{
                type: String,
                default:''
            },
        },
        watch: {
            videoUrl: {
                handler(newVal, old) {
                    this.reloadUrl(true);
                },
                deep: true,
            },
        },
        data() {
            return {
                player: null,
                refDom: null,
                reloadUrlCount:0,
                isFirefox:false,
                isLoading:false,
                checkIframetimer:null,
                lastDecodedFrame:0,
                lastDecodedFrameCount:0,
            }
        },
        created() {
            this.isFirefox = isFirefoxBrowser()
        },
        mounted() {

            this.initvideoPlayer();
            const _this = this;
            clearInterval()
            this.checkIframetimer = setInterval(() => {
                if (_this.player && _this.player.buffered && _this.player.buffered.length) {
                    let end = _this.player.buffered.end(0);//获取当前buffered值
                    let diff = end - _this.player.currentTime;//获取buffered与currentTime的差值
                    if (diff >= 2.0) {//如果差值大于等于2.0 手动跳帧 这里可根据自身需求来定
                        _this.player.currentTime = _this.player.buffered.end(0);//手动跳帧
                    }
                }
            }, 2000);

        },
        methods: {
            reloadUrl(sourceChange){
                console.log(sourceChange)

                this.reloadUrlCount++;
                // 重新加载超过10次销毁播放组件不再重新请求
                if(!sourceChange && (this.reloadUrlCount > this.limitReloadCount) && this.player){
                    this.player.detachMediaElement();
                    this.isLoading = false;
                    this.player.destroy();
                    this.player = null;
                    return;
                }

                if(sourceChange){
                    this.reloadUrlCount = 0;
                }

                if(this.player){
                    this.player.pause();
                    this.player.unload();
                    this.player.detachMediaElement();
                    this.player.destroy();
                    this.player= null;
                }
                this.initvideoPlayer();
            },
            ended(e) {
                this.$emit("flvEnded", true);
            },
            error(e) {
                let err = e.target.error;
                // console.error(err);
                if (err.code == 4) {
                    //error.code; //1.用户终止 2.网络错误 3.解码错误 4.playUrl无效
                    // this.reloadUrl();
                }
                this.isLoading = false;
            },
            loadstart() {
                this.isLoading = true;
            },
            canplay(e) {
                //资源可以播放
                let dom = e.target;
                dom.play();
                this.isLoading = false;
                this.$emit("isplay", true);
            },
            play(){ //播放
                if(this.player){
                    this.player.load(); //加载
                    this.player.play();
                }
            },
            pause(){ // 暂停
                if(this.player){
                    this.player.pause();
                }
            },
            initvideoPlayer(){
                this.refDom = this.$refs.flvPlayerVideoRef;
                if(!this.videoUrl){
                    this.refDom.src = '';
                    return
                }

                let videoUrl = '';
                if(this.videoUrl.indexOf('http') > -1){
                    videoUrl = this.videoUrl;
                }else{
                    videoUrl = `ws://${this.serverUrl}/live/${this.voice==true?1:0}/?url=${this.videoUrl}` /*阿里云转码服务*/
                }


                if (flvjs.isSupported() && this.videoCode == 'flv') {

                    this.player = flvjs.createPlayer({
                            type: this.videoCode,
                            url: videoUrl,
                            withCredentials: false,
                            isLive:false
                        },
                        {
                            enableWorker: true,
                            lazyLoad: false,
                            seekType: 'range',
                            lazyLoadMaxDuration: 20 * 60,
                        });
                    this.player.attachMediaElement(this.refDom);
                    this.player.load(); //加载
                    this.player.play();
                    this.player.on("error", (err) => {
                        console.log('err', err);
                        if (err == "MediaError") {
                            this.reloadUrl();
                        }
                    });

                    this.player.on(flvjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
                        console.log("errorType:", errorType);
                        console.log("errorDetail:", errorDetail);
                        console.log("errorInfo:", errorInfo);
                        if(errorInfo.code == -1){
                            this.$message({message: "视频源出错", type: "error"});
                        }
                        //视频出错后销毁重新创建
                        this.reloadUrl();
                    });

                    this.player.on(flvjs.Events.MEDIA_SOURCE_CLOSE, (res) =>{
                        console.log("MEDIA_SOURCE_CLOSE",res)
                    })
                    this.player.on(flvjs.Events.MEDIA_SOURCE_ENDED, (res) =>{
                        console.log("MEDIA_SOURCE_ENDED",res)
                    })
                    this.player.on(flvjs.Events.VIDEO_RESOLUTION_CHANGED, (res) =>{
                        console.log("VIDEO_RESOLUTION_CHANGED",res)
                    })
                    this.player.on(flvjs.Events.VIDEO_FROZEN, (res) =>{
                        console.log("VIDEO_FROZEN",res)
                    })

                    this.player.on("statistics_info",  (res) =>{
                        if (this.lastDecodedFrame == 0) {
                            this.lastDecodedFrame = res.decodedFrames;
                            return;
                        }
                        if (this.lastDecodedFrame != res.decodedFrames) {
                            this.lastDecodedFrame = res.decodedFrames;
                        } else {
                            this.lastDecodedFrameCount ++ ;
                            if(this.lastDecodedFrameCount > 5){
                                this.lastDecodedFrame = 0;
                                this.lastDecodedFrameCount = 0 ;
                                this.reloadUrl()
                            }

                        }
                    });
                    
                    
                    
                    try {
                        this.player.load();
                        this.player.play();
                    } catch (error) {
                        console.log(error);
                    }

                }else{

                    this.refDom.src = this.videoUrl;

                }
            },

            // 视频截图及上传文件服务器
            cutVideoScreen(){

                var fileType = "png";  // 如果文件名中没有带后缀，默认使用png
                var video = this.$refs.flvPlayerVideoRef;  // 找到需要截图的video标签
                var canvas = window.canvas = document.createElement("canvas");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);  // 图片大小和视频分辨率一致
                var strDataURL = canvas.toDataURL("image/" + fileType);   // canvas中video中取一帧图片并转成dataURL
                var arr = strDataURL.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var blob = new Blob([u8arr], {
                    type: mime
                });

                const formData = new FormData();
                formData.append('file', blob);

                if(blob){

                    this.$http.post('/bigfileUpload/uploadFile',formData ).then(res => {


                        if(res.data.code == "1"){
                            var filePath = res.data.data;
                            this.$emit('cutAndUploadSuccess', filePath);

                        }else{
                            this.$message({message: "上传失败", type: "error"});
                        }

                    }).catch(e => {

                    })

                }
            },

        },

        destroyed() {
            clearInterval(this.checkIframetimer)
        },
    }
</script>

<style lang="less" scoped>
    .player-box {
        position: relative;
        width:100%;
        height:100%;
        .video-body {
            width: 100%;
            height: 100%;
            object-fit:fill;
        }
        .loader {
            width: 140px;
            height: 140px;
            text-align: center;
            position: absolute;
            top: calc(50% - 40px);
            left: calc(50% - 70px);
            padding-top: 15px;
            z-index: 900;
            border-radius: 5px;

            .loader-1 {
                width: 60px;
                height: 60px;
            }
            svg path,
            svg rect {
                fill: #17a085;
            }
        }
        .load-msg {
            height: 50px;
            line-height: 50px;
            color: #fff;
            font-size: 13px;
            margin-top: 20px;
        }
    }


</style>